import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CorporateService } from 'src/app/services/corporate.service';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-create-corporate',
  templateUrl: './create-corporate.component.html',
  styleUrls: ['./create-corporate.component.css']
})
export class CreateCorporateComponent implements OnInit {
  public corporateForm: UntypedFormGroup;
  title: string;
  api_error: string;
  api_success: string;
  btndisabled = false;
  domains: any = [];
  subDomains: any = [];
  selectedDomainId: any;
  domain: any;


  constructor(
    private formbuilder: UntypedFormBuilder,
    private corporateService: CorporateService,
    private matDialog: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private customValidator: CustomValidatorService,
    private commonService: CommonfilterService) {
      this.createCorporateForm();
      this.title = 'CREATE';
      this.getServiceSectors();
  }

  formErrors = {
    'corporateName': '',
    'corporateCode': '',
    // 'corporateUid': '',
    'multilevel': '',
    'centralised': '',
    'contactPersonMobNo': '',
    'contactPersonLastName': '',
    'contactPersonFirstName': '',
    'officeEmail': '',
    'officePhone': '',



  };

  ValidationMessages = {
    'corporateName': {
      'required': 'Name is required',
      'whitespace': 'Corporate Name is invalid'

    },
    'corporateCode': {
      'required': 'Code  is required',
      'whitespace': 'Code is invalid'
    },
    // 'corporateUid': {
    //   'required': 'Uid is required',
    //   'whitespace': 'Uid is invalid'
    // },


    'officeEmail': {
      'required': 'office Email is required'

    },
    'officePhone': {
      'required': 'Office Phone is required',
      'minlength': 'Phone number should have a minimum length of 10 characters',
      'maxlength': 'Phone number should only have a maximum length of 10 characters',
      'pattern': 'Only numbers are allowed'
    },
    'contactPersonMobNo': {
      'required': 'Mobile number is required',
      'minlength': 'Phone number should have a minimum length of 10 characters',
      'maxlength': 'Phone number should only have a maximum length of 10 characters',
      'pattern': 'Only numbers are allowed'
    },
    'contactPersonLastName': {
      'required': 'Last Name is required',
      'whitespace': 'Last Name is invalid'
    },
    'contactPersonFirstName': {
      'required': 'First Name is required',
      'whitespace': 'First Name is invalid'
    },

  };

  getServiceSectors() {
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.domains = res;
    if (this.data['type'] === 'edit') {
      this.updateCorporateForm(this.data['corporate']);
      this.title = 'UPDATE';
    }
      });
  }
  ngOnInit() {
  }
  createCorporateForm() {
    this.corporateForm = this.formbuilder.group({
      corporateId: [''],
      corporateName: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      corporateCode: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      // corporateUid: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      multilevel: ['false'],
      centralised: ['false'],
      contactPersonMobNo: ['', [Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      contactPersonLastName: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      contactPersonFirstName: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      address: [''],
      officeEmail: ['', [Validators.required]],
      officePhone: ['', [Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]],
      lattitude: [''],
      longitude: [''],
      location: [''],
      domain: [''],
      subDomain: [''],
      licPkgId: [9]


    });
  }
  logValidationErrors(group: UntypedFormGroup = this.corporateForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }
  updateCorporateForm(corporate) {
    this.corporateForm.patchValue({
      corporateId: corporate.corporateId,
      corporateName: corporate.corporateName,
      corporateCode: corporate.corporateCode,
      // corporateUid: corporate.corporateUid,
      multilevel: corporate.multilevel,
      centralised: corporate.centralised,
      contactPersonMobNo: corporate.contactPersonMobNo,
      contactPersonLastName: corporate.contactPersonLastName,
      contactPersonFirstName: corporate.contactPersonFirstName,
      address: corporate.address,
      officeEmail: corporate.officeEmail,
      officePhone: corporate.officePhone,
      lattitude: corporate.lattitude,
      longitude: corporate.longitude,
      location: corporate.location,
      domain: corporate.domain,


    });
    this.setSubdomain(corporate);
    if (corporate.multilevel) {
      this.corporateForm.get('multilevel').setValue('true');
    } else {
      this.corporateForm.get('multilevel').setValue('false');
    }
    if (corporate.centralised) {
      this.corporateForm.get('centralised').setValue('true');
    } else {
      this.corporateForm.get('centralised').setValue('false');
    }
  }
  setSubdomain(corporate) {
    for (let i = 0; i < this.domains.length; i++) {
    if (this.domains[i].id === corporate.domain) {
      for (let j = 0; j < this.domains[i].subDomains.length; j++) {
        this.subDomains.push({
          'displayName': this.domains[i].subDomains[j].displayName,
          'id': this.domains[i].subDomains[j].id, 'subDomain': this.domains[i].domain + '_' + this.domains[i].subDomains[j].subDomain
        });
      }
      this.corporateForm.get('subDomain').setValue(corporate.subDomain);

    }
    }
  }

  onDomainChange(event) {
    this.subDomains = [];
    this.selectedDomainId = event;
    for (let i = 0; i < this.domains.length; i++) {
      // tslint:disable-next-line:triple-equals
      if (this.selectedDomainId === this.domains[i].id) {
        this.domain = this.domains[i].domain;
        for (let j = 0; j < this.domains[i].subDomains.length; j++) {
          this.subDomains.push({
            'displayName': this.domains[i].subDomains[j].displayName,
            'id': this.domains[i].subDomains[j].id, 'subDomain': this.domains[i].domain + '_' + this.domains[i].subDomains[j].subDomain
          });
          this.corporateForm.get('subDomain').enable();
        }
      }
    }
  }


  onCorporateSubmit() {
    // if (this.corporateForm.invalid) {
    //   this.api_error = 'Please fill all the required fields of corporate';
    // } else {
      this.btndisabled = true;
      this.api_error = '';
      if (this.data['type'] === 'edit') {
        this.corporateService.updateCorporate(this.corporateForm.value)
          .subscribe(res => {
            this.api_success = 'Corporate updated successfully';
            setTimeout(() => {
              this.matDialog.close();
            }, 2000);
          },
            (error) => {
              this.api_error = error.error;
              this.btndisabled = false;
            });
      } else {
        this.corporateService.createCorporate(this.corporateForm.value)
          .subscribe(res => {
            this.api_success = 'Corporate created successfully';
            setTimeout(() => {
              this.matDialog.close();
            }, 2000);
          },
            (error) => {
              this.api_error = error.error;
              this.btndisabled = false;
            });
      }
   // }
  }

}
